import { render, staticRenderFns } from "./staffLeaveTask.vue?vue&type=template&id=3a6e2850&scoped=true"
import script from "./staffLeaveTask.vue?vue&type=script&lang=js"
export * from "./staffLeaveTask.vue?vue&type=script&lang=js"
import style0 from "./staffLeaveTask.vue?vue&type=style&index=0&id=3a6e2850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6e2850",
  null
  
)

export default component.exports